import Vue from 'vue'

import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'

export function getCustomTabsList (config) {
  const { create, access, subtypeKey, objectData } = config
  const objectSrc = objectData && objectData.object || null

  return [
    {
      key: 'params',
      name: 'Основное',
      props: [
        { key: '$key', name: 'Логин исполнителя в Яндекс', _visible: access.viewPrivate, _editable: access.editPrivate },
        { key: 'registrationTime', name: 'Дата регистрации учетной записи', _visible: access.viewPrivate, _editable: access.editPrivate },
        { key: 'accountEmployee', name: 'Исполнитель', _visible: access.viewPrivate, _editable: access.editPrivate },
        { key: 'fio', name: 'ФИО исполнителя', _visible: !create && access.viewPrivate, _editable: false },
        { key: 'accountAssignedEmployee', name: 'Назначенный пользователь учетной записи', _visible: !create && access.viewPrivate, _editable: access.editPrivate },
        { key: 'assignedEmployeeFio', name: 'ФИО назначенного пользователя учетной записи', _visible: !create && access.viewPrivate, _editable: false },
        { key: 'assignedEmployeeChanged', name: 'Назначенный пользователь учетной записи изменен', _visible: !create && access.viewPrivate, _editable: false },
        { key: 'accountRequest', name: 'Заявка (текущая)', _visible: !create && access.viewPrivate, _editable: false },
        { key: 'departureNumber', name: 'Номер выезда', _visible: !create && access.viewPrivate, _editable: false },
        { key: 'useState', name: 'Статус использования учетной записи', _visible: !create && access.viewPrivate, _editable: access.editPrivate },
        { key: 'active', name: 'Учетная запись активна', _visible: access.viewPrivate, _editable: access.editPrivate },
        { key: 'updateTime', name: 'Дата/время внесения изменений', _visible: !create && access.viewPrivate, _editable: access.editPrivate }
      ]
    }
  ]
}
